import { ViewMain } from "./Components/View";


const ManagerEntity = () => {

    return (<ViewMain />);
};

export default ManagerEntity;